export const SET_SNIPPETS = 'SET_SNIPPETS';
export const SET_QUERY = 'SET_QUERY';
export const SET_LOADING = 'SET_LOADING';
export const SET_LOADED = 'SET_LOADED';
export const SET_ACTIVE = 'SET_ACTIVE';
export const SET_INACTIVE = 'SET_INACTIVE';
export const SET_PLAYING = 'SET_PLAYING';
export const SET_PAUSED = 'SET_PAUSED';
export const SET_DURATION = 'SET_DURATION';
export const SET_TIME = 'SET_TIME';
export const SET_SEEK = 'SET_SEEK';
export const SET_INITIAL = 'SET_INITIAL';

export const setInitial = () => {
  return {
    type: SET_INITIAL,
    payload: {},
  };
};

export const setSnippets = (payload) => {
  return {
    type: SET_SNIPPETS,
    payload: payload,
  };
};

export const setLoading = () => {
  return {
    type: SET_LOADING,
    payload: {},
  };
};

export const setLoaded = () => {
  return {
    type: SET_LOADED,
    payload: {},
  };
};

export const setQuery = (query) => {
  return {
    type: SET_QUERY,
    payload: { query },
  };
};

export const setActive = (active) => {
  return {
    type: SET_ACTIVE,
    payload: { active },
  };
};

export const setInactive = () => {
  return {
    type: SET_INACTIVE,
    payload: {},
  };
};

export const setPlaying = () => {
  return {
    type: SET_PLAYING,
    payload: {},
  };
};

export const setPaused = () => {
  return {
    type: SET_PAUSED,
    payload: {},
  };
};

export const setDuration = (duration) => {
  return {
    type: SET_DURATION,
    payload: { duration },
  };
};

export const setTime = (time) => {
  return {
    type: SET_TIME,
    payload: { time },
  };
};

export const setSeek = (seek) => {
  return {
    type: SET_SEEK,
    payload: { seek },
  };
};

export const fetchSnippets =
  (query, page = 1) =>
  async (dispatch) => {
    dispatch(setLoading());
    await fetch(
      `https://6yqsnc5kqi.execute-api.us-east-1.amazonaws.com/dev/search/${query}?page=${page}`
    )
      .then((response) => response.json())
      .then((response) => {
        dispatch(setSnippets(response));
        dispatch(setQuery(query));
        dispatch(setLoaded());
      })
      .catch((err) => console.error(err));
  };
